import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { User, Logueo } from '../../models/user';
import { ParameterConst } from 'src/app/util/constant';
import { environment } from 'src/environments/environment'; 
import { AlertaService } from 'src/app/util/alerta.service';
import { MsjDialogService } from 'src/app/service/msjDialogService';
import { UserService } from 'src/app/service/user.service';
import { DataService } from 'src/app/common/data.service';

@Component({
  selector: 'app-form-user',
  templateUrl: './form-user.component.html',
  styleUrls: ['./form-user.component.css']
})
export class FormUserComponent implements OnInit {

  @ViewChildren ('checkBoxReg' ) checkBoxReg:QueryList<any>;
  @ViewChildren ('checkBoxApr' ) checkBoxApr:QueryList<any>;
  @ViewChildren ('checkBoxPub' ) checkBoxPub:QueryList<any>;

  userForm:FormGroup;
  user: User;
  data:string;
  
  usu: User;
  sqUsuario:string="";

  arrTematicas;
  selectedReg = [];
  selectedApr = [];
  selectedPub = [];

  arrCheckedReg = [];//["0", "3", "4"];
  arrCheckedApr = [];
  arrCheckedPub = [];

  constructor(private route: ActivatedRoute,
    private fb: FormBuilder, private router: Router,
    private msjSnackBar : MsjDialogService, private userService: UserService,
    private dataService : DataService) {
      this.user = new User();

      dataService.apiEditUsu$.subscribe(data => this.usu = data);
      this.usu = this.usu;


   }

  ngOnInit(): void {

    this.setForm();


  }

  existeReg(id: any): boolean {

    if(this.arrCheckedReg){
      return this.arrCheckedReg.some(elt => elt === id);
    }else{
      return false;
    }
    
  }


  existeApr(id: any): boolean {

    if(this.arrCheckedApr){
      return this.arrCheckedApr.some(elt => elt === id);
    }else{
      return false;
    }
    
  }


  existePub(id: any): boolean {

    if(this.arrCheckedPub){
      return this.arrCheckedPub.some(elt => elt === id);
    }else{
      return false;
    }
    
  }

  setForm(){
    this.userForm = this.fb.group({
      nombreCompleto: ['', Validators.required],
      correo: ['', Validators.required],
      pass: ['']
    })   
  }


  obtenerTematicas(){


    this.dataService.obtenerTematicas().pipe().subscribe(result => {

      if(result){
        this.arrTematicas = result;
      }

    },
      error =>{
        this.msjSnackBar.openMensaje(ParameterConst.API_DISCONNET,ParameterConst.MESSAGE_SERFOR);
      }
    );

  }

  registrarUsuario(){

    
  }


  retornarListado(){
    this.router.navigate(['/admin/users']);
  }

  toggleReg(event){

    this.selectedReg = []; 
     const checked = this.checkBoxReg.filter(checkbox => checkbox.checked);

       checked.forEach(data => {
            this.selectedReg.push (data.value)
       })

  }

  toggleApr(event){
    this.selectedApr = []; 
     const checked = this.checkBoxApr.filter(checkbox => checkbox.checked);

       checked.forEach(data => {
            this.selectedApr.push (data.value)
       })

  }

  togglePub(event){
    this.selectedPub = []; 
     const checked = this.checkBoxPub.filter(checkbox => checkbox.checked);

       checked.forEach(data => {
            this.selectedPub.push (data.value)
       })

  }


}


